
import { Vue, Options } from "vue-class-component";
import { reactive } from "vue";
import Toaster from "../../helpers/Toaster";
import { useStore, ActionTypes } from "../../store";
import UserAuthentication from "../../service/UserAuthentication";
import router from "../../router";
import { email, helpers, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

@Options({
  components: {},
  title: "User login",
})
export default class Login extends Vue {
  private showProgress = false;
  private showPassword = false;
  private toast;
  private submitted = false;
  private state = reactive({
    email: "",
    password: "",
    errorMessage:"",
  });

  private rules = {
    email: {
      required:helpers.withMessage("Email is required",required),
      email:helpers.withMessage("Enter a valid Email",email),
    },
    password: {
      required:helpers.withMessage("Password is required",required),
    },
  };

  private v$ = useVuelidate(this.rules, this.state);

  created() {
    this.toast = new Toaster();
  }

  mounted() {
    this.checkNewInstallation();
  }

  checkNewInstallation() {
    const auth = new UserAuthentication();

    auth.checkNewInstallation().then((res) => {
      if (!res) {
        router.replace({ path: "/install",});
      }
    });
  }

  cleanError(){
    this.state.errorMessage = '';
  }


authenticate(isFormValid) {
  //console.log("authenticate function called");
  this.submitted = true;
  this.state.errorMessage = ""; // Reset previous error message

  if (isFormValid) {
    //console.log("isformvalid ", isFormValid);
    const auth = new UserAuthentication();
    const store = useStore();
    this.showProgress = true;

    auth
      .loginUser(this.state.email.trim(), this.state.password.trim(), "Web")
      .then((res) => {
        //console.log("LOGIN RESPONSE ", res);
        if (res && res.message !== "Invalid credentials") {
          this.toast.showSuccess("Greetings " + res.userName);
          store.dispatch(ActionTypes.AUTH_REQUEST, res.token);
          store.dispatch(ActionTypes.GET_CURRENCY, res.currency);
          store.dispatch(ActionTypes.PERMISSION_LIST, res.permissionList);
          store.dispatch(ActionTypes.ROLE, res.role);
          router.replace({ path: "/home/dashboard" });
        } else {
          this.state.errorMessage = "Invalid email or password."; // Set error message
          //console.log("Invalid login credentials");
        }
      })
      .catch((error) => {
        this.showProgress = false;
        console.error("Login error:", error);

        if (error.response && error.response.status === 401) {
          this.state.errorMessage = "Invalid email or password."; // Handle 401 errors
        } else {
          this.state.errorMessage = "An error occurred. Please try again.";
        }

        this.resetForm(false); // Do not reset errorMessage
      });
  } else {
    //console.log("The form is invalid");
  }

  this.showProgress = false;
}

resetForm(clearError = true) {
  this.state.email = "";
  this.state.password = "";
  this.submitted = false;
  if (clearError) {
    this.state.errorMessage = "";
  }
}
  

togglePassword() {
  this.showPassword = !this.showPassword;
}


}


